import React from "react";
import { FeeStatus, RegistrationStatus } from "../../Base/AdoptionConstants";
import { Typography } from "@material-ui/core";
import useAlerts from "../../Base/AlertProvider";
import { CheckCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import { updateRegistrationFeeStatus } from "../../Base/Services/RegistrationService";
import useAdminContext from "../AdminContextProvider";
import ButtonWithLoadingSpinner from "../../Base/Components/ButtonWithLoadingSpinner";

export default function RegistrationPaymentVerification({ registration, setRegistration }) {
  const { addErrorAlert } = useAlerts();
  const paymentStatus = React.useMemo(() => FeeStatus[registration.feeStatus], [registration]);
  const [processingUpdate, setProcessingUpdate] = React.useState();
  const adminContext = useAdminContext();
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Typography variant="body1">
            <b style={{ marginRight: 4 }}>Status:</b>
          </Typography>
          <Typography variant="body1" style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
            <span id="dialog-payment-status" style={{ marginRight: 2 }}>
              {paymentStatus.label}
            </span>
            {paymentStatus === FeeStatus.FEE_PAID || paymentStatus === FeeStatus.FEE_WAIVED ? (
              <CheckCircleOutline style={{ color: "green" }} />
            ) : (
              <RemoveCircleOutline />
            )}
          </Typography>
        </div>
        {[FeeStatus.PREV_PAID_PENDING, FeeStatus.UPDATE_FEE_PENDING, FeeStatus.FEE_PENDING].includes(paymentStatus) && (
          <ButtonWithLoadingSpinner
            color="primary"
            variant="contained"
            isLoading={processingUpdate}
            onClick={() => {
              setProcessingUpdate(true);
              const statusToUpdateTo =
                paymentStatus === FeeStatus.PREV_PAID_PENDING ? FeeStatus.FEE_WAIVED.value : FeeStatus.FEE_PAID.value;
              updateRegistrationFeeStatus(registration.registrationId, statusToUpdateTo)
                .then(setRegistration)
                .then(adminContext.triggerDataResync)
                .catch(() => addErrorAlert("There was an error completing the operation"))
                .finally(() => setProcessingUpdate(false));
            }}
          >
            {paymentStatus === FeeStatus.PREV_PAID_PENDING ? "Verify Fee Waived" : "Verify Payment"}
          </ButtonWithLoadingSpinner>
        )}
        {(paymentStatus === FeeStatus.FEE_PAID || paymentStatus === FeeStatus.FEE_WAIVED) && (
          <ButtonWithLoadingSpinner
            color="default"
            variant="outlined"
            isLoading={processingUpdate}
            onClick={() => {
              setProcessingUpdate(true);
              const statusToUpdateTo =
                paymentStatus === FeeStatus.FEE_PAID
                  ? registration.registrationStatus === RegistrationStatus.NEEDS_RESEARCH.value
                    ? FeeStatus.UPDATE_FEE_PENDING // UPDATE_FEE when needs research
                    : FeeStatus.FEE_PENDING // Normal fee when not needs research
                  : FeeStatus.PREV_PAID_PENDING;
              updateRegistrationFeeStatus(registration.registrationId, statusToUpdateTo.value)
                .then(setRegistration)
                .then(adminContext.triggerDataResync)
                .catch(() => addErrorAlert("There was an error completing the operation"))
                .finally(() => setProcessingUpdate(false));
            }}
          >
            {paymentStatus === FeeStatus.FEE_PAID ? "Revoke Payment Verification" : "Revoke Fee Waived Verification"}
          </ButtonWithLoadingSpinner>
        )}
      </div>
    </div>
  );
}
